<template>
  <SimpleFormModal
    ref="simpleFormModal"
    :form="form"
  />
</template>

<script>
import HttpStatus from 'http-status-codes'
import { createLocation } from '@/api/locations/request'
import notification from '@/utils/notification'
import navigation from '@/utils/navigation'
import { ROUTER_PATHS } from '@/constants/router'
import { SITE_TYPE } from '@/constants/modeltypes'
import { utils as formUtil } from '@/plugin/InputChange'
import SimpleFormModal from '@/controls/SimpleFormModal'
import i18n from '@/utils/i18n'

export default {
  name: 'AddSiteModal',
  components: {
    SimpleFormModal,
  },
  computed: {
    form () {
      const result = Object.values(SITE_TYPE)
      const siteTypeOptions = result.map(this.$options.filters['capitalize'])
      return [
        {
          type: 'text',
          name: 'code',
          label: this.$t('settings.site.name'),
          value: '',
          required: true,
        },
        {
          type: 'multiSelect',
          name: 'type',
          label: this.$t('settings.site.type'),
          value: '',
          options: siteTypeOptions,
          customLabel: this.customSiteTypeLabel,
          required: true,
        },
        {
          type: 'text',
          name: 'note',
          label: this.$t('settings.site.description'),
          value: '',
          required: true,
        },
        {
          type: 'text',
          name: 'subsidiary',
          label: this.$t('settings.site.companyName'),
          value: '',
          required: true,
        },
      ]
    },
  },
  methods: {
    open () {
      let self = this
      this.$refs.simpleFormModal.open().setConfirmCallback(async data => {
        let generatedId
        try {
          data.type = data.type.toUpperCase()
          generatedId = await createLocation(data)
          self.$refs.simpleFormModal.close()
          formUtil.resetDirty()
          if (generatedId) {
            navigation.toPage(ROUTER_PATHS.SITE_PROFILE, { id: generatedId })
          }
        } catch (err) {
          const response = err.response
          if (response.status === HttpStatus.CONFLICT) {
            const validMsgKey = `error.site.${response.status}`
            this.$refs.simpleFormModal.setErrHint(`${i18n.t(validMsgKey)}`)
          } else {
            notification.handleResponseError(err, 'site')
          }
        }
      })
    },
    customSiteTypeLabel (value) {
      return value ? this.$t(`settings.site.${value.toLowerCase()}`) : this.$t('emptyValue')
    },
  },
}
</script>
